module.exports = __webpack_public_path__ + "static/media/Davos_Tipp_2.8031cbfc.jpg";